module.exports = "/out/52543ba96cae6786b6496e543a1e964e.svg";